module.exports = __webpack_public_path__ + "static/Portfolio13-657141a408afe2e7aea4863cf560536f.jpg";